import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AssetAssignments.css";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";

import {
  FaSearch,
  FaFilter,
  FaPlus,
  FaEye,
  FaEdit,
  FaExchangeAlt,
  FaUndo,
} from "react-icons/fa";

const AssetAssignments = () => {
  const navigate = useNavigate();
  
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editAsset, setEditAsset] = useState(null);
  const [inventoryAssets, setInventoryAssets] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
  status: "",
  department: "",
  brand: "",
  assignedFrom: "",
  assignedTo: "",
    });
  const [showReplaceModal, setShowReplaceModal] = useState(false);
  const [replaceAsset, setReplaceAsset] = useState(null);
  const [replacementData, setReplacementData] = useState({
    return_status: "Returned",
    return_date: "",
    old_remarks: "",

    asset_name: "",
    new_asset_number: "",
    brand: "",
    model: "",
    serial_number: "",

    replacement_remarks: "",
    });
  
    const uniqueDepartments = [
    ...new Set(
        assignments
        .map((item) => item.department)
        .filter(Boolean)
    ),
    ];

    const uniqueBrands = [
    ...new Set(
        assignments
        .map((item) => item.brand)
        .filter(Boolean)
    ),
    ];
  useEffect(() => {
    fetchAssets();

  }, []);

const [showReturnModal, setShowReturnModal] = useState(false);
const [returnAsset, setReturnAsset] = useState(null);
const [returnData, setReturnData] = useState({
  return_date: "",
  remarks: "",
});

useEffect(() => {
  const fetchInventory = async () => {
    try {
      const data = await apiClient(
        "/assetinventory/inventory/list/"
      );

      const list = Array.isArray(data)
        ? data
        : data.results || [];

      setInventoryAssets(list);
    } catch (err) {
      console.error(err);
    }
  };

  fetchInventory();
}, []);

useEffect(() => {
  let data = [...assignments];

  if (searchTerm) {
    data = data.filter(
      (item) =>
        item.employee_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.employee_id
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.asset_number
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.brand
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.model
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );
  }

  if (filters.status) {
    data = data.filter(
      (item) => item.status === filters.status
    );
  }

  if (filters.department) {
    data = data.filter(
      (item) => item.department === filters.department
    );
  }

  if (filters.brand) {
    data = data.filter(
      (item) => item.brand === filters.brand
    );
  }

  if (filters.assignedFrom) {
    data = data.filter(
      (item) =>
        item.assigned_date >= filters.assignedFrom
    );
  }

  if (filters.assignedTo) {
    data = data.filter(
      (item) =>
        item.assigned_date <= filters.assignedTo
    );
  }

  setFilteredData(data);
}, [assignments, searchTerm, filters]);

  const fetchAssets = async () => {
    try {
      const data = await apiClient(
        "/assets/list/"
      );

      const assetList = Array.isArray(data)
        ? data
        : data?.results || data?.assets || [];

      setAssignments(assetList);
      setFilteredData(assetList);
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);

    const filtered = assignments.filter(
      (item) =>
        item.employee_name
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.employee_id
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.asset_number
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.brand
          ?.toLowerCase()
          .includes(value.toLowerCase()) ||
        item.model
          ?.toLowerCase()
          .includes(value.toLowerCase())
    );

    setFilteredData(filtered);
  };

const handleView = (asset) => {
  setSelectedAsset(asset);
  setShowViewModal(true);
};

const handleEdit = (asset) => {
  setEditAsset({ ...asset });
  setShowEditModal(true);
};

const handleEditChange = (e) => {
  const { name, value } = e.target;

  setEditAsset((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleUpdateAsset = async () => {
  try {
    await apiClient(
      `/assets/update/${editAsset.id}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editAsset),
      }
    );

    // Close Edit Modal
    setShowEditModal(false);
    setEditAsset(null);

    setSuccessMessage("Asset Updated Successfully");
    setShowSuccessModal(true);

    fetchAssets();
  } catch (error) {
    console.error(error);
  }
};

const handleReplaceChange = (e) => {
  const { name, value } = e.target;

  setReplacementData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleReplaceLaptop = async () => {
  try {

    // Step 1: Update old laptop assignment
    await apiClient(
      `/assets/update/${replaceAsset.id}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...replaceAsset,
          status: replacementData.return_status,
          return_date: replacementData.return_date,
          remarks: replacementData.old_remarks,
        }),
      }
    );

    // Step 2: Create new laptop assignment
    await apiClient(
      "/assets/add/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          employee_id: replaceAsset.employee_id,
          employee_name: replaceAsset.employee_name,
          email: replaceAsset.email,
          department: replaceAsset.department,
          designation: replaceAsset.designation,
          asset_name: replacementData.asset_name,
          asset_number:
            replacementData.new_asset_number,

          brand: replacementData.brand,

          model: replacementData.model,

          serial_number:
            replacementData.serial_number,

          assigned_date:
            replacementData.return_date,

          status: "Active",

          remarks:
            replacementData.replacement_remarks,
        }),
      }
    );

    setSuccessMessage("Laptop Replaced Successfully");
    setShowSuccessModal(true);


    fetchAssets();

  } catch (error) {
    console.error("Replace Error:", error);
    setSuccessMessage("Failed to replace laptop");
    setShowSuccessModal(true);
  }
};

const handleReturnLaptop = async () => {
  try {
    await apiClient(`/assets/update/${returnAsset.id}/`, {
      method: "PUT",
      body: JSON.stringify({
        ...returnAsset,
        status: "Returned",
        return_date: returnData.return_date,
        remarks: returnData.remarks,
      }),
    });

    setShowReturnModal(false);
    setReturnAsset(null);

    setSuccessMessage("Laptop Returned Successfully");
    setShowSuccessModal(true);

    fetchAssets();
  } catch (error) {
    console.error(error);
    alert("Failed to return laptop");
  }
};

const handleReassign = (asset) => {
  setReplaceAsset(asset);

  setReplacementData({
    return_status: "Returned",
    return_date: "",
    old_remarks: "",
    new_asset_number: "",
    brand: "",
    model: "",
    serial_number: "",
    replacement_remarks: "",
  });

  setShowReplaceModal(true);
};

const handleReplacementAssetSelect = (e) => {
  const assetNumber = e.target.value;

  const asset = inventoryAssets.find(
    a => a.asset_number === assetNumber
  );

  if (!asset) return;

  setReplacementData(prev => ({
    ...prev,
    new_asset_number: asset.asset_number,
    asset_name: asset.asset_name,
    brand: asset.brand,
    model: asset.model,
    serial_number: asset.serial_number,
  }));
};


  const handleReturn = (asset) => {
    setReturnAsset(asset);

    setReturnData({
        return_date: "",
        remarks: asset.remarks || "",
    });

    setShowReturnModal(true);
    };

  return (
    <div className="asset-page">
      <div className="asset-top">
        <div>
          <h2>Laptop Assignments</h2>
        </div>
      </div>

  <div className="asset-toolbar">
    <div className="search-box">
        <input
        type="text"
        placeholder="Search employee, asset, brand, model..."
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        />
    </div>

    <button
        className="filter-btn"
        onClick={() => setShowFilters(!showFilters)}
    >
        <FaFilter />
        Filters
    </button>

    <button
        className="new-btn"
        onClick={() =>
        navigate("/dashboard/ManagerAcess/addasset")
        }
    >
        <FaPlus />
        New Assignment
    </button>
 </div>

{showFilters && (
  <div className="filter-panel">

    <div className="filter-group">
      <label>Status</label>
      <select
        value={filters.status}
        onChange={(e) =>
          setFilters({
            ...filters,
            status: e.target.value,
          })
        }
      >
        <option value="">All</option>
        <option value="Active">Active</option>
        <option value="Returned">Returned</option>
        <option value="Reassigned">Reassigned</option>
      </select>
    </div>

    <div className="filter-group">
        <label>Department</label>

        <select
            value={filters.department}
            onChange={(e) =>
            setFilters({
                ...filters,
                department: e.target.value,
            })
            }
        >
            <option value="">All</option>

            {uniqueDepartments.map((dept) => (
            <option key={dept} value={dept}>
                {dept}
            </option>
            ))}
        </select>
        </div>
    <div className="filter-group">
        <label>Brand</label>

        <select
            value={filters.brand}
            onChange={(e) =>
            setFilters({
                ...filters,
                brand: e.target.value,
            })
            }
        >
            <option value="">All</option>

            {uniqueBrands.map((brand) => (
            <option key={brand} value={brand}>
                {brand}
            </option>
            ))}
        </select>
        </div>

    <div className="filter-group">
      <label>Assigned From</label>
      <input
        type="date"
        value={filters.assignedFrom}
        onChange={(e) =>
          setFilters({
            ...filters,
            assignedFrom: e.target.value,
          })
        }
      />
    </div>

    <div className="filter-group">
      <label>Assigned To</label>
      <input
        type="date"
        value={filters.assignedTo}
        onChange={(e) =>
          setFilters({
            ...filters,
            assignedTo: e.target.value,
          })
        }
      />
    </div>

    <div className="filter-group">
      <button
        className="clear-filter-btn"
        onClick={() =>
          setFilters({
            status: "",
            department: "",
            brand: "",
            assignedFrom: "",
            assignedTo: "",
          })
        }
      >
        Clear Filters
      </button>
    </div>

  </div>
)}

<div className="table-card">
        <div className="table-responsive">
          <table className="asset-table">
            <thead>
              <tr>
                {/* <th>ID</th> */}
                <th>Employee ID</th>
                <th>Name</th>
                <th>Department</th>
                <th>Asset Name</th>
                <th>Asset No</th>
                <th>Brand</th>
                <th>Model</th>
                <th>Assigned Date</th>
                <th>Returned Date</th>
                <th>Status</th>
                <th>Remarks</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                    {/* <td>{item.id}</td> */}

                    <td>{item.employee_id}</td>

                    <td className="employee-name">
                      {item.employee_name}
                    </td>

                    <td>{item.department}</td>
                    
                    <td>{item.asset_name}</td>

                    <td className="asset-number">
                      {item.asset_number}
                    </td>

                    <td>{item.brand}</td>

                    <td>{item.model}</td>

                    <td>{item.assigned_date}</td>

                    <td>
                    {item.return_date
                        ? item.return_date
                        : "—"}
                    </td>

                    {/* <td>
                    <span
                        className={`status-badge status-${(
                        item.status || "active"
                        ).toLowerCase()}`}
                    >
                        {item.status}
                    </span>
                    </td> */}

                    <td>
                      <span
                        className={`status-badge status-${(
                          item.status || "active"
                        ).toLowerCase()}`}
                      >
                        {item.status}
                      </span>
                    </td>

                    <td>{item.remarks || "-"}</td>

                    <td>
                      <div className="action-icons">
                        <FaEye
                          title="View"
                          className="view-icon"
                          onClick={() => handleView(item)}
                        />

                        <FaEdit
                          title="Edit"
                          className="edit-icon"
                          onClick={() => handleEdit(item)}
                        />

                        {item.status !== "Returned" && (
                        <FaExchangeAlt
                            title="Replace"
                            className="reassign-icon"
                            onClick={() => handleReassign(item)}
                        />
                        )}

                        {item.status !== "Returned" && (
                        <FaUndo
                            title="Return"
                            className="return-icon"
                            onClick={() => handleReturn(item)}
                        />
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="11"
                    style={{
                      textAlign: "center",
                      padding: "20px",
                    }}
                  >
                    No Asset Assignments Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <span>
            Showing {filteredData.length} of{" "}
            {assignments.length}
          </span>
        </div>
      </div>
    {showViewModal && selectedAsset && (
  <div className="view-modal-overlay">
    <div className="view-modal">

      <div className="view-modal-header">
        <h3>
          Assignment : {selectedAsset.id}
        </h3>

        <button
          className="close-btn"
          onClick={() => setShowViewModal(false)}
        >
          ✕
        </button>
      </div>

      <div className="view-modal-body">

        <div className="view-section">
          <h4>Employee Details</h4>

          <div className="detail-grid">
            <div className="detail-item">
              <label>Employee ID</label>
              <span>{selectedAsset.employee_id}</span>
            </div>

            <div className="detail-item">
              <label>Name</label>
              <span>{selectedAsset.employee_name}</span>
            </div>

            <div className="detail-item">
              <label>Department</label>
              <span>{selectedAsset.department}</span>
            </div>

            <div className="detail-item">
              <label>Designation</label>
              <span>{selectedAsset.designation}</span>
            </div>

            <div className="detail-item">
              <label>Email</label>
              <span>{selectedAsset.email}</span>
            </div>
          </div>
        </div>

        <div className="view-section">
          <h4>Laptop Details</h4>

          <div className="detail-item">
            <label>Asset Name</label>
            <span>{selectedAsset.asset_name}</span>
        </div>

          <div className="detail-grid">
            <div className="detail-item">
              <label>Asset Number</label>
              <span>{selectedAsset.asset_number}</span>
            </div>

            <div className="detail-item">
              <label>Brand</label>
              <span>{selectedAsset.brand}</span>
            </div>

            <div className="detail-item">
              <label>Model</label>
              <span>{selectedAsset.model}</span>
            </div>

            <div className="detail-item">
              <label>Serial Number</label>
              <span>{selectedAsset.serial_number}</span>
            </div>

            <div className="detail-item">
              <label>Assigned Date</label>
              <span>{selectedAsset.assigned_date}</span>
            </div>

            <div className="detail-item">
              <label>Status</label>
              <span
                className={`status-badge status-${selectedAsset.status?.toLowerCase()}`}
              >
                {selectedAsset.status}
              </span>
            </div>
          </div>
        </div>

        <div className="view-section">
          <h4>Remarks</h4>

          <div className="remarks-box">
            {selectedAsset.remarks || "-"}
          </div>
        </div>

      </div>

      <div className="view-modal-footer">
        <button
          className="close-modal-btn"
          onClick={() => setShowViewModal(false)}
        >
          Close
        </button>
      </div>

    </div>
  </div>
)}

{showEditModal && editAsset && (
  <div className="edit-modal-overlay">
    <div className="edit-modal">

      <div className="edit-modal-header">
        <h3>Edit AS-{editAsset.id}</h3>

        <button
          className="close-btn"
          onClick={() => setShowEditModal(false)}
        >
          ✕
        </button>
      </div>

      <div className="edit-modal-body">

        <div className="edit-grid">

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={editAsset.email || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Department</label>
            <input
              type="text"
              name="department"
              value={editAsset.department || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Designation</label>
            <input
              type="text"
              name="designation"
              value={editAsset.designation || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          {/* <div className="form-group">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={editAsset.location || ""}
              onChange={handleEditChange}
            />
          </div> */}

        </div>

        <h4 className="modal-section-title">
          LAPTOP
        </h4>

        <div className="edit-grid">
          <div className="form-group">
            <label>Asset Name</label>

            <input
                type="text"
                name="asset_name"
                value={editAsset.asset_name || ""}
                disabled
                onChange={handleEditChange}
            />
        </div>

          <div className="form-group">
            <label>Asset Number *</label>
            <input
              type="text"
              name="asset_number"
              value={editAsset.asset_number || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Brand *</label>
            <input
              type="text"
              name="brand"
              value={editAsset.brand || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Model *</label>
            <input
              type="text"
              name="model"
              value={editAsset.model || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Serial Number</label>
            <input
              type="text"
              name="serial_number"
              value={editAsset.serial_number || ""}
              disabled
              onChange={handleEditChange}
            />
          </div>

        </div>

        <h4 className="modal-section-title">
          ASSIGNMENT
        </h4>

        <div className="edit-grid">

          <div className="form-group">
            <label>Assigned Date *</label>
            <input
              type="date"
              name="assigned_date"
              value={editAsset.assigned_date || ""}
              onChange={handleEditChange}
            />
          </div>

          <div className="form-group">
            <label>Status</label>

            <input
                type="text"
                value={editAsset.status || ""}
                disabled
                className="readonly-input"
            />
            </div>

        </div>

        <div className="form-group">
          <label>Remarks</label>
          <textarea
            rows="4"
            name="remarks"
            value={editAsset.remarks || ""}
            onChange={handleEditChange}
          />
        </div>

      </div>

      <div className="edit-modal-footer">

        <button
          className="cancel-edit-btn"
          onClick={() => setShowEditModal(false)}
        >
          Cancel
        </button>

        <button
          className="save-edit-btn"
          onClick={handleUpdateAsset}
        >
          Save
        </button>

      </div>

    </div>
  </div>
)}

{showReturnModal && returnAsset && (
  <div className="return-modal-overlay">
    <div className="return-modal">

      <div className="return-header">
        <h3>Return Laptop</h3>

        <button
          className="close-btn"
          onClick={() => setShowReturnModal(false)}
        >
          ✕
        </button>
      </div>

      <div className="return-body">

        <div className="current-assignment">

          <div className="assignment-grid">

            <div>
              <label>Employee</label>
              <span>
                {returnAsset.employee_name}
                ({returnAsset.employee_id})
              </span>
            </div>

            <label>Asset</label>

            <span>
            {replaceAsset.asset_name} - {replaceAsset.asset_number}
            </span>
            <div>
              <label>Assigned</label>
              <span>
                {returnAsset.assigned_date}
              </span>
            </div>

          </div>

        </div>

        <div className="form-group">
          <label>Return Date *</label>

          <input
            type="date"
            value={returnData.return_date}
            onChange={(e) =>
              setReturnData({
                ...returnData,
                return_date: e.target.value,
              })
            }
          />
        </div>

        <div className="form-group">
          <label>Return Remarks</label>

          <textarea
            rows="4"
            value={returnData.remarks}
            onChange={(e) =>
              setReturnData({
                ...returnData,
                remarks: e.target.value,
              })
            }
          />
        </div>

      </div>

      <div className="return-footer">

        <button
          className="cancel-btn1"
          onClick={() => setShowReturnModal(false)}
        >
          Cancel
        </button>

        <button
          className="return-btn"
          onClick={handleReturnLaptop}
        >
          Mark Returned
        </button>

      </div>

    </div>
  </div>
)}

{showReplaceModal && replaceAsset && (
  <div className="replace-modal-overlay">
    <div className="replace-modal">

      <div className="replace-header">
        <h3>
          Replace Laptop — {replaceAsset.employee_name}
        </h3>

        <button
          className="close-btn"
          onClick={() => setShowReplaceModal(false)}
        >
          ✕
        </button>
      </div>

      <div className="replace-body">

        <div className="current-assignment">
          <h4>STEP 1 — CURRENT ASSIGNMENT</h4>

          <div className="assignment-grid">
            <div>
              <label>Employee</label>
              <span>
                {replaceAsset.employee_name}
              </span>
            </div>

            <div>
              <label>Department</label>
              <span>
                {replaceAsset.department}
              </span>
            </div>

            <div>
              <label>Asset</label>
              <span>
                {replaceAsset.asset_number} — {replaceAsset.brand}
              </span>
            </div>

            <div>
              <label>Assigned Since</label>
              <span>
                {replaceAsset.assigned_date}
              </span>
            </div>
          </div>
        </div>

        <h4 className="section-title">
          STEP 2 — CLOSE CURRENT ASSIGNMENT
        </h4>

        <div className="replace-grid">

          <div className="form-group">
            <label>Mark Old Laptop As</label>
            <select
              name="return_status"
              value={replacementData.return_status}
              onChange={handleReplaceChange}
            >
              <option>Returned</option>
              <option>Damaged</option>
              <option>Lost</option>
            </select>
          </div>

          <div className="form-group">
            <label>Return Date</label>
            <input
              type="date"
              name="return_date"
              value={replacementData.return_date}
              onChange={handleReplaceChange}
            />
          </div>

        </div>

        <div className="form-group">
          <label>Remarks For Old Record</label>

          <textarea
            rows="3"
            name="old_remarks"
            value={replacementData.old_remarks}
            onChange={handleReplaceChange}
          />
        </div>

        <h4 className="section-title">
          STEP 3 — NEW  ASSET  DETAILS
        </h4>

        <div className="replace-grid">
          <div className="form-group">
            <label>Asset Name *</label>

            <select
                name="asset_name"
                value={replacementData.asset_name}
                onChange={(e) =>
                setReplacementData((prev) => ({
                    ...prev,
                    asset_name: e.target.value,
                    new_asset_number: "",
                    brand: "",
                    model: "",
                    serial_number: "",
                }))
                }
            >
                <option value="">Select Asset Name</option>

                {[...new Set(
                inventoryAssets
                    .filter(asset => asset.asset_status === "Available")
                    .map(asset => asset.asset_name)
                )].map(name => (
                <option key={name} value={name}>
                    {name}
                </option>
                ))}
            </select>
            </div>
          <div className="form-group">
            <label>Asset Number *</label>

            <select
                value={replacementData.new_asset_number}
                onChange={handleReplacementAssetSelect}
            >
                <option value="">Select Asset Number</option>

                {inventoryAssets
                .filter(
                    asset =>
                    asset.asset_name === replacementData.asset_name &&
                    asset.asset_status === "Available"
                )
                .map(asset => (
                    <option
                    key={asset.id}
                    value={asset.asset_number}
                    >
                    {asset.asset_number}
                    </option>
                ))}
            </select>
            </div>
          

          <div className="form-group">
            <label>Brand *</label>
            <input
                type="text"
            value={replacementData.brand}
            readOnly
/>
          </div>

          <div className="form-group">
            <label>Model *</label>
            <input
                type="text"
                value={replacementData.model}
                readOnly
                />
          </div>

          <div className="form-group">
            <label>Serial Number</label>

            <input
                type="text"
                value={replacementData.serial_number}
                readOnly
            />
            </div>

        </div>

        <div className="form-group">
          <label>Replacement Remarks</label>

          <textarea
            rows="3"
            name="replacement_remarks"
            value={replacementData.replacement_remarks}
            onChange={handleReplaceChange}
          />
        </div>

      </div>

      <div className="replace-footer">
        <button
          className="cancel-btn1"
          onClick={() => setShowReplaceModal(false)}
        >
          Cancel
        </button>

        <button
          className="replace-btn"
          onClick={handleReplaceLaptop}
        >
          Replace Laptop
        </button>
      </div>

    </div>
  </div>
)}

{showSuccessModal && (
  <div className="success-overlay">
    <div className="success-modal">

      <div className="success-icon">
        ✓
      </div>

      <h3>Success</h3>

      <p>{successMessage}</p>

      <button
        className="success-btn"
        onClick={() => {
            setShowSuccessModal(false);

            setShowReplaceModal(false);
            setReplaceAsset(null);

            setShowReturnModal(false);
            setReturnAsset(null);

            fetchAssets();
        }}
        >
        OK
        </button>

    </div>
  </div>
)}

      <SessionHandler />
    </div>
  );
};

export default AssetAssignments;